const truncateStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  padding: '4px 2px'
};

export const tableColumns = [
  {
    name: 'ID',
    selector: row => row.donation_object_id,
    sortable: true,
    center: true,
    width: '70px',
    style: truncateStyle,
  },
  {
    name: 'Entity Name',
    selector: row => row.object_name,
    sortable: true,
    center: true,
    width: '260px',
    cell: row => (
      <div style={{
        ...truncateStyle,
        color: '#5C61F2',
        fontWeight: 'bold',
        width: '100%',
        textAlign: 'center'
      }}>
        {row.object_name}
      </div>
    ),
  },
  {
    name: 'Type',
    selector: row => row.type_label,
    sortable: true,
    center: true,
    width: '130px',
    style: truncateStyle,
  },
  // {
  //   name: 'Location',
  //   selector: row => row.object_location || '-',
  //   sortable: true,
  //   center: true,
  //   width: '180px',
  //   style: truncateStyle,
  // },
  {
    name: '# Items',
    selector: row => row.active_item_count,
    sortable: true,
    center: true,
    width: '90px',
    style: truncateStyle,
  },
  {
    name: 'Updated',
    selector: row => row.updated_date,
    sortable: true,
    center: true,
    width: '120px',
    style: truncateStyle,
  },
  {
    name: 'Settlement',
    selector: row => row.settlement_mode,
    cell: row => (
      <span
        className={`badge ${row.settlement_mode === 'DIRECT' ? 'bg-warning text-dark' : 'bg-info text-dark'}`}
        style={{ padding: '6px 10px' }}
      >
        {row.settlement_mode === 'DIRECT' ? 'Direct UPI' : 'MyParikrama'}
      </span>
    ),
    sortable: true,
    center: true,
    width: '140px',
    style: truncateStyle,
  },
  {
    name: 'Status',
    selector: row => row.status_component,
    sortable: false,
    center: true,
    width: '110px',
    id: 'status',
    style: truncateStyle,
  },
  {
    name: 'Action',
    selector: row => row.action,
    sortable: false,
    center: true,
    width: '140px',
    id: 'action',
    style: truncateStyle,
  }
];

export const ENTITY_TYPES = [
  { value: 'TEMPLE', label: 'Temples' },
  { value: 'TEERTHA', label: 'Teerthas' },
  { value: 'SAINT', label: 'Saints' },
  { value: 'PROJECT', label: 'Projects' },
  { value: 'LIVE_DARSHAN', label: 'Live Darshan' }
];

export const typeLabel = (value) => {
  const found = ENTITY_TYPES.find(t => t.value === value);
  return found ? found.label.replace(/s$/, '') : value;
};
